<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.emballage.emballage')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <div class="flex items-center">
                    <img class="hidden md:block h-14" src="https://disticloudfiles.net/img/savinfo/default/box-package.png" alt="">
                    <div class="ml-2">
                        <div class="text-lg font-bold" v-if="selected == '0'" test-id="end-label">{{$t('form.emballage.je_ne_souhaite_pas_recevoir_d_emballage')}}</div>
                        <div class="text-lg font-bold text-green-600" v-if="selected == '1'" test-id="end-label">{{$t('form.emballage.je_souhaite_recevoir_un_emballage')}}</div>
                        <div class="text-sm font-light">{{$t('form.emballage.pour_l_envoi_de_mon_appareil')}}</div>
                    </div>
                </div>
            </template>

            <template v-slot:open>
                <div class="flex items-center">
                    <img class="hidden md:block h-28" src="https://disticloudfiles.net/img/savinfo/default/box-package.png" alt="">
                    <div class="md:ml-4">
                        <template v-if="step == 0">
                            <h1 class="text-lg font-bold">{{$t('form.emballage.possedez_vous_un_emballage_pour_renvoyer_votre_appareil_?')}}</h1>
                            <div class="mt-2">
                                <button @click="end('0')" class="px-4 py-2 text-sm font-light text-green-700 duration-200 bg-green-200 border-green-200 rounded hover:bg-green-300" test-id="have">
                                    <i class="mr-1 fas fa-check"></i> {{$t('form.emballage.oui')}}
                                </button>
                                <button @click="noHavePackage" class="px-4 py-2 ml-2 text-sm font-light text-red-700 duration-200 bg-red-200 border-red-200 rounded hover:bg-red-300" test-id="doesnt-have">
                                    <i class="mr-1 fas fa-times"></i> {{$t('form.emballage.non')}}
                                </button>
                            </div>
                        </template>
                        <template v-if="step == 1">
                            <h1 class="text-lg font-bold">{{$t('form.emballage.souhaitez_vous_commander_un_emballage_?')}}</h1>
                            <p class="text-sm font-light">{{$t('form.emballage.un_supplement_de')}} <b>{{price}}€</b> {{$t('form.emballage.vous_sera_demande_plus_tard')}}</p>
                            <div class="mt-2">
                                <button @click="end('1')" class="px-4 py-2 text-sm font-light text-green-700 duration-200 bg-green-200 border-green-200 rounded hover:bg-green-300" test-id="add-package">
                                    <i class="mr-1 fas fa-check"></i> {{$t('form.emballage.oui')}} (+{{price}}€)
                                </button>
                                <button @click="end('0')" class="px-4 py-2 ml-2 text-sm font-light text-red-700 duration-200 bg-red-200 border-red-200 rounded hover:bg-red-300" test-id="not-add-package">
                                    <i class="mr-1 fas fa-times"></i> {{$t('form.emballage.non')}}
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'packaging',
    extends: FormCardExtension,

    data() {
        return {
            step: 0,
            price: 0,
        }
    },

    methods: {
        init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextBlock()
            }

            this.price = this.$formTool.getFormData('device')[0].value.emballage

            this.loading = false
        },

        async end(callbackData) {
            if (callbackData == 1) {
                let response = await apiService.post('dem_emballage', {
                    id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
                })
            }
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            if (this.selected == callbackData) {
                this.emitChange()
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        getNextBlock() {
            return this.$formTool.blockData(this.$options.name).next.stations
        },

        noHavePackage() {
            const hasWarranty = JSON.parse(JSON.parse(this.$crypto.decrypt(JSON.parse(localStorage['form-data'])['set-case']))).garantie
            if (hasWarranty) {
                this.end(1)
            } else {
                this.step++
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/PackagingCard.vue